module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Warning-1-circle-c234a4a362d90dd59e18d453964623eb.svg";